import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useReferences() {
  const { data, isLoading } = useQuery({
    queryKey: ["references"],
    queryFn: async () => (await api.get("/references")).data,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
  return { references: data || {}, loading: isLoading };
}

export function labelFor(list, value) {
  if (!list) return value;
  const item = list.find((x) => x.value === value);
  return item ? item.label : value;
}
